import { PromptView } from '@lemoncloud/ssocio-chatbots-api';

/**
 * 프롬프트가 템플릿인지 판별하는 함수
 * (isStock: true이거나 id가 '#'으로 시작하는 경우) OR (parentId가 없거나 빈 문자열인 경우) 템플릿으로 간주
 * useTemplatePrompts로 가져온 프롬프트도 모두 템플릿으로 처리
 */
export const isTemplatePrompt = (prompt: PromptView): boolean => {
    const isStockOrSpecialId = Boolean(prompt.isStock) || Boolean(prompt.id && prompt.id.startsWith('#'));
    const hasNoParentId = !prompt.parentId || prompt.parentId === '';
    return isStockOrSpecialId || hasNoParentId;
};

/**
 * useTemplatePrompts 훅으로 가져온 프롬프트인지 판별하는 함수
 * ID가 '#'으로 시작하는 경우 useTemplatePrompts로 가져온 것으로 간주
 */
export const isFromTemplateHook = (prompt: PromptView): boolean => {
    return Boolean(prompt.id && prompt.id.startsWith('#'));
};

/**
 * 프롬프트 목록에서 템플릿 프롬프트만 필터링하는 함수
 */
export const filterTemplatePrompts = (prompts: PromptView[]): PromptView[] => {
    return prompts.filter(isTemplatePrompt);
};
